var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.646,
    height: 16.259,
    viewBox: "0 0 12.646 16.259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M5.9,17.453A1.812,1.812,0,0,0,7.71,19.259h7.226a1.812,1.812,0,0,0,1.807-1.807V6.613H5.9Zm2.222-6.432L9.4,9.748l1.924,1.915,1.915-1.915,1.274,1.274L12.6,12.936l1.915,1.915-1.274,1.274L11.323,14.21,9.408,16.125,8.134,14.851l1.915-1.915ZM14.485,3.9l-.9-.9H9.065l-.9.9H5V5.71H17.646V3.9Z",
    transform: "translate(-5 -3)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRedIcon);
export default __webpack_public_path__ + "static/media/delete_red_icon.45baa1ff21a452ef463af5f380e1b3e0.svg";
export { ForwardRef as ReactComponent };